import Layout from '@/views/layout/App.vue'
import Empty from "@/views/layout/Empty";

export default {
    path: '/role_permissions',
    name: 'RolePermissions',
    meta: {
        title: '设置',
        isAdmin: true
    },
    component: Layout,
    redirect: '/role_permissions/role_list',
    children: [
        {
            path: 'admin_role',
            name: 'AdminRole',
            meta: {
                title: '总后台管理员',
                isAdmin: true
            },
            component: resolve => require(['@/views/rolePermissions/adminRole/Index.vue'], resolve),
        },
        {
            path: 'study_center_role',
            name: 'StudyCenterRole',
            meta: {
                title: '学习中心管理员',
                isAdmin: true
            },
            component: resolve => require(['@/views/rolePermissions/studyCenterRole/Index.vue'], resolve),
        },
        {
            path: 'role_and_permissions',
            name: 'RoleAndPermissions',
            meta: {
                title: '总后台管理员',
                isAdmin: true
            },
            component: resolve => require(['@/views/rolePermissions/roleAndPermissions/Index.vue'], resolve),
        },
        {
            path: 'role_list',
            meta: {
                title: '角色列表列表',
                isAdmin: true
            },
            component: Empty,
            children: [
                {
                    path: 'role_bind_org',
                    name: 'RoleBindRrg',
                    alias: '/role_bind_org_list',
                    meta: {
                        title: '分配机构',
                        isAdmin: true
                    },
                    component: resolve => require(['@/views/rolePermissions/orgBindRole/Index.vue'], resolve),
                },
            ]
        },
    ]
}
